import Vue from 'vue'
import VueRouter from 'vue-router'
import PinkfongProductList from 'app/contents/PinkfongProductList.vue'
import PinkfongProductDetail from 'app/contents/PinkfongProductDetail.vue'
import LicenseProductList from 'app/contents/LicenseProductList.vue'
import LicenseProductDetail from 'app/contents/LicenseProductDetail.vue'
import MediaContentList from 'app/contents/MediaContentList.vue'
import MediaContentDetail from 'app/contents/MediaContentDetail.vue'
import SelectedProducts from 'app/contents/SelectedProducts.vue'
import SearchProducts from 'app/contents/SearchProducts.vue'
import Home from 'app/contents/Home.vue'
import { getDefaultLanguage } from 'utils/utils.js'

Vue.use(VueRouter)

const routerView = { template: '<router-view></router-view>' }

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/home',
      name: 'home',
      component: Home
    },
    {
      path: '/',
      component: routerView,
      children: [
        {
          path: ':lang',
          component: routerView,
          children: [
            {
              path: 'pinkfongproducts',
              component: routerView,
              meta: {
                breadcrumb: '핑크퐁 제품'
              },
              children: [
                {
                  path: 'all',
                  component: routerView,
                  children: [
                    {
                      name: 'pinkfongproducts_all',
                      path: '',
                      component: PinkfongProductList
                    },
                    {
                      name: 'pinkfongproducts_all_detail',
                      path: ':id',
                      component: PinkfongProductDetail
                    }
                  ]
                },
                {
                  path: ':category',
                  component: routerView,
                  children: [
                    {
                      name: 'pinkfongproducts_category',
                      path: '',
                      component: PinkfongProductList
                    },
                    {
                      name: 'pinkfongproducts_category_detail',
                      path: ':id',
                      component: PinkfongProductDetail
                    }
                  ]
                }
              ]
            },
            {
              path: 'licensedproducts',
              component: routerView,
              meta: {
                breadcrumb: '핑크퐁 라이선스 제품'
              },
              children: [
                {
                  path: 'all',
                  component: routerView,
                  children: [
                    {
                      name: 'licensedproducts_all',
                      path: '',
                      component: LicenseProductList
                    },
                    {
                      name: 'licensedproducts_all_detail',
                      path: ':id',
                      component: LicenseProductDetail
                    }
                  ]
                },
                {
                  path: ':category',
                  component: routerView,
                  children: [
                    {
                      name: 'licensedproducts_category',
                      path: '',
                      component: LicenseProductList
                    },
                    {
                      name: 'licensedproducts_category_detail',
                      path: ':id',
                      component: LicenseProductDetail
                    }
                  ]
                }
              ]
            },
            {
              path: 'mediacontent',
              component: routerView,
              meta: {
                breadcrumb: '핑크퐁 미디어 콘텐츠'
              },
              children: [
                {
                  path: 'all',
                  component: routerView,
                  children: [
                    {
                      name: 'mediacontent_all',
                      path: '',
                      component: MediaContentList
                    },
                    {
                      name: 'mediacontent_all_detail',
                      path: ':id',
                      component: MediaContentDetail
                    }
                  ]
                },
                {
                  path: ':category',
                  component: routerView,
                  children: [
                    {
                      name: 'mediacontent_category',
                      path: '',
                      component: MediaContentList
                    },
                    {
                      name: 'mediacontent_category_detail',
                      path: ':id',
                      component: MediaContentDetail
                    }
                  ]
                }
              ]
            },
            {
              name: 'selected_list',
              path: 'selected',
              component: SelectedProducts,
              meta: {
                breadcrumb: 'Selected Items'
              }
            },
            {
              name: 'search_list',
              path: 'search',
              component: SearchProducts,
              meta: {
                breadcrumb: 'Search Results'
              }
            },
            {
              name: 'home_default_path',
              path: '',
              component: Home
            }
          ]
        },
        {
          path: '',
          redirect: { name: 'home' }
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (!to.params.lang && !from.params.lang) {
    let locale = getDefaultLanguage()
    Vue.prototype.$language.locale = locale
    to.params.lang = locale
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/app/router.js